import {
  Component,
  OnInit,
  Input,
  Inject,
  ViewEncapsulation,
} from "@angular/core";
import { CompanyDataService } from "../company-data.service";
import { environment } from "../../../environments/environment";
import { faRegistered } from "@fortawesome/free-solid-svg-icons";
import {
  faEnvelope,
  faRegistered as faRegisteredLight,
} from "@fortawesome/pro-light-svg-icons";
import {
  chevronLeft,
  chevronRight,
  guidance,
  VAIconRegistryService,
  clock,
  closeCircle,
  fileExcel,
  flag,
  infoCircle,
  minusCircle,
  sync,
} from "@va/core-library/icons";
import { HttpClient } from "@angular/common/http";
import { DOCUMENT, DatePipe } from "@angular/common";
import { Store } from "@ngrx/store";
import { AppState, stateGetter } from "src/app/store/state/app.state";
import { Dictionary } from "src/app/store/models/common_types";
import { CompanyPageMeta } from "src/app/store/models/company-page-store.model";
import { SafeResourceUrl, DomSanitizer } from "@angular/platform-browser";
import { AppService } from "../../app.service";
import {
  AnalystModelDataResponse,
  TearSheetErrorResponse,
} from "../company-page.model";
import { Observable } from "rxjs";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { CompanyAnnouncementDialogComponent } from "src/app/shared/company-announcement-dialog/company-announcement-dialog.component";

@Component({
  selector: "app-analyst-models",
  templateUrl: "./analyst-models.component.html",
  styleUrls: ["./analyst-models.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class AnalystModelsComponent implements OnInit {
  reaffirmedSupportLink =
    environment.SUPPORT_LINKS.base_link +
    environment.SUPPORT_LINKS.en_US +
    environment.SUPPORT_LINKS.articles.reaffirmed_in_consensus;
  extraInfo: string;
  footerText: string;
  footerHoverMsg: string;
  @Input() ticker: string;
  analystModelData: Array<any>;
  legacyUrl = `${window.caUrl}/app`;
  apiUrl: string = window.apiUrl;
  assets = environment.assetUrl;
  faRegistered = faRegistered;
  faRegisterdLight = faRegisteredLight;
  faEnvelope = faEnvelope;
  brokerAscOrder: Array<string>;
  brokerDescOrder: Array<string>;
  analystDescOrder: Array<string>;
  eventDateAscOrder: Array<string>;
  eventDateDescOrder: Array<string>;
  analystAscOrder: Array<any>;
  consesusAscOrder: Array<any>;
  consesusDescOrder: Array<any>;
  originalValuesObj: any;
  userType: string;
  companyId;
  viewModalSrc: SafeResourceUrl;
  companyFlag;
  isViewModalVisible = false;
  gettingPDFURL = false;
  usersnapJsKey: string;
  snapEmail: string;
  userName: string;
  errorMsg = "Something went wrong!";
  filingsError = false;
  filingsHeading: string;
  datePublish: string;
  documentType: string;
  documentId: number;
  currentGuidance = 0;
  guidanceCount = 0;
  hasGuidance: boolean;
  guidanceList;
  dataObservable: Observable<AnalystModelDataResponse | TearSheetErrorResponse>;
  columnSortDirections = ["ascend", "descend", null];
  filingFileType;

  private dialogRef: MatDialogRef<CompanyAnnouncementDialogComponent>;

  constructor(
    private service: CompanyDataService,
    private store: Store<AppState>,
    public sanitizer: DomSanitizer,
    private iconRegistryService: VAIconRegistryService,
    private http: HttpClient,
    private appService: AppService,
    @Inject(DOCUMENT) private _document: HTMLDocument,
    public dialog: MatDialog,
  ) {
    this.iconRegistryService.registerIcons([
      chevronLeft,
      chevronRight,
      guidance,

      infoCircle,

      flag,

      closeCircle,

      fileExcel,

      clock,

      sync,

      minusCircle,
    ]);
  }

  ngOnInit() {
    this.store
      .select(stateGetter("companyPage", "meta"))
      .subscribe((data: Dictionary<CompanyPageMeta>) => {
        if (data[this.ticker]) {
          const meta = data[this.ticker];
          this.companyId = meta.companyid;
          this.userType = meta.user_type;
          this.companyFlag = meta.company_flag;
        }
      });

    this.store
      .select(stateGetter("globalHeader", "globalSettings"))
      .subscribe((data: any) => {
        this.usersnapJsKey = data.usersnapJsKey;
        this.snapEmail = data.userDetails ? data.userDetails.email : "";
        this.userName = data.userName;
      });
    this.dataObservable = this.service.getAnalystModelData(this.ticker);
  }
  onAnalystDataResolved(resp) {
    const analystData = resp.analyst_published_data;
    this.footerText = analystData.non_entitled_source_message
      ? analystData.non_entitled_source_message.msg
      : "";
    this.footerHoverMsg = analystData.non_entitled_source_message
      ? analystData.non_entitled_source_message.hover_msg
      : "";
    if (analystData.number_of_brokers) {
      this.extraInfo = `${analystData.number_of_brokers} analyst`;
      this.extraInfo +=
        analystData.number_of_brokers > 1 ? " models" : " model";
      this.extraInfo += " available";
      if (analystData.consensus_participating_sources) {
        this.extraInfo += ` | ${analystData.consensus_participating_sources}`;
        this.extraInfo +=
          analystData.consensus_participating_sources > 1
            ? " analysts"
            : " analyst";
        this.extraInfo += " in consensus";
      }
    }
    this.brokerAscOrder = analystData.asc_broker ? analystData.asc_broker : [];
    this.brokerDescOrder = analystData.desc_broker
      ? analystData.desc_broker
      : [];
    this.analystDescOrder = analystData.desc_analyst
      ? analystData.desc_analyst
      : [];
    this.eventDateAscOrder = analystData.latest_broker_model_list
      ? analystData.latest_broker_model_list
      : [];
    this.eventDateDescOrder = analystData.latest_broker_model_list_desc
      ? analystData.latest_broker_model_list_desc
      : [];
    this.analystAscOrder = analystData.asc_analyst
      ? analystData.asc_analyst
      : [];
    this.consesusAscOrder = analystData.asc_consesus
      ? analystData.asc_consesus
      : [];
    this.consesusDescOrder = analystData.desc_consesus
      ? analystData.desc_consesus
      : [];
    this.originalValuesObj = analystData.values;
    this.getSortedData("ascend", "eventDate");
  }

  getSortedData(sortOrder, sortBy) {
    let sortingArr = [];
    switch (sortBy) {
      case "eventDate":
        if (sortOrder === "ascend") {
          //sort date ascending
          sortingArr = this.eventDateAscOrder;
        } else if (sortOrder === "descend") {
          //sort date descending
          sortingArr = this.eventDateDescOrder;
        } else {
          sortingArr = this.eventDateAscOrder;
        }
        break;
      case "brokerShortName":
        if (sortOrder === "ascend") {
          //sort broker ascending
          sortingArr = this.brokerAscOrder;
        } else if (sortOrder === "descend") {
          sortingArr = this.brokerDescOrder;
        } else {
          //sort broker descending
          sortingArr = this.eventDateAscOrder;
        }
        break;
      case "analyst":
        if (sortOrder === "ascend") {
          //sort analyst ascending
          sortingArr = this.analystAscOrder;
        } else if (sortOrder === "descend") {
          //sort analyst descending
          sortingArr = this.analystDescOrder;
        } else {
          //sort analyst descending
          sortingArr = this.eventDateAscOrder;
        }
        break;
      case "consensusStatus":
        if (sortOrder === "ascend") {
          //sort consensus ascending
          sortingArr = this.consesusAscOrder;
        } else if (sortOrder === "descend") {
          //sort consensus descending
          sortingArr = this.consesusDescOrder;
        } else {
          //sort consensus descending
          sortingArr = this.eventDateAscOrder;
        }
        break;
      default:
        break;
    }
    this.analystModelData = this.getTableData(sortingArr);
  }
  getTableData(sortingArr) {
    const tableData = [];
    sortingArr.forEach((element) => {
      const valueRow = this.originalValuesObj[element];
      let field = "all";
      if (valueRow.name === "Earnings") {
        field = "earnings";
      } else if (valueRow.restrict_review_flag === 1) {
        field = "notCurrentModel";
      } else if (valueRow.drop_coverage === 1) {
        field = "droppedCoverage";
      } else if (valueRow.name === "Interim") {
        field = "interim";
      }
      const row = {
        fields: field,
        showLink: valueRow.is_give_to_get_src === 0,
        brokerShortName: element,
        brokerFullName: valueRow.name,
        showWaterFront: valueRow.show_waterfront,
        waterFrontTitle: valueRow.wf_comment,
        totalModels: valueRow.total_models,
        isDropCoverage: valueRow.drop_coverage,
        earningsData: valueRow.name === "Earnings" ? valueRow.row_data[0] : {},
        interimData: valueRow.name === "Interim" ? valueRow.row_data[0] : {},
        isNotCurrentModel: valueRow.restrict_review_flag === 1,
        showAsReported: valueRow.show_as_reported,
        brokerPrioritized: valueRow.broker_prioritized,
        brokerPriorityText: valueRow.broker_priority_text,
        consensusStatus: valueRow.consensus_status,
        awaiting_process_disabled: valueRow.awaiting_process_disabled,
        statedperiodtooltip: valueRow.statedperiod,
        documentType: valueRow.row_data[0],
        countryid: valueRow.countryid,
        brokerPrioritizedComment:
          valueRow.broker_prioritized &&
          valueRow.broker_prioritized_comment !== undefined &&
          valueRow.broker_prioritized_comment !== ""
            ? valueRow.broker_prioritized_comment
            : false,
        innerTable: {
          show: false,
          offset: 0,
          data: [],
        },
        expand: false,
        sourceId: valueRow.source_id,
        entitledModel: valueRow.entitled_model,
        subRow: {},
      };
      if (valueRow.row_data.length > 0) {
        const valueSubRow = valueRow.row_data[0];
        // innerTable needed params to be repeated in expand object
        const subRow = {
          eventDate:
            valueSubRow.event_date !== null &&
            typeof valueSubRow.event_date === "string"
              ? (valueSubRow.event_date as string).replace("Z", "")
              : valueSubRow.event_date,
          dayDiff: valueSubRow.daydiff,
          analystId: valueSubRow.analyst_id,
          analystName: valueSubRow.analyst_name,
          analystEmail: String(valueSubRow.analyst_email).toLowerCase(),
          fileSize: valueSubRow.file_size,
          fileName: valueSubRow.file_name,
          transactionId: valueSubRow.TransactionId,
          modelType: valueSubRow.model_type,
          downloadApplicable: valueSubRow.download_applicable,
          pg: valueRow.pg,
          hasDuplicate: valueSubRow.has_duplicate,
          isReaffirm: valueSubRow.reaffirm ? valueSubRow.reaffirm : false,
          reaffirmType:
            valueSubRow.reaffirmType === 0 || valueSubRow.reaffirmType === 1
              ? valueSubRow.reaffirmType
              : null,
          effectivestart: valueSubRow.effectivestart
            ? valueSubRow.effectivestart
            : null,
          isInProgress:
            this.userType !== "MODELS_ONLY_INBOX" &&
            valueRow.pg !== "" &&
            valueRow.drop_coverage === 0 &&
            valueRow.is_give_to_get_src === 0 &&
            valueSubRow.coverage_analyst_data === 0 &&
            valueSubRow.isabandoned === false,
          transactionStatus: valueSubRow.Transaction_Status,
          transactionComment:
            valueSubRow.Transaction_Comment &&
            valueSubRow.Transaction_Comment !== ""
              ? valueSubRow.Transaction_Comment
              : false,
          showViewLink:
            this.userType !== "MODELS_ONLY_INBOX" &&
            valueRow.pg !== "" &&
            valueRow.is_give_to_get_src === 0 &&
            valueSubRow.coverage_analyst_data === 1,
          duplicateList: [],
        };
        if (valueSubRow.model_date !== undefined) {
          subRow["model_date"] = valueSubRow.model_date;
        }
        row["subRow"] = subRow;
      }
      tableData.push(row);
    });
    return tableData;
  }
  expandRow(valueRow, showMoreClick) {
    let offset = 1;
    if (!valueRow.innerTable.offset) {
      offset = valueRow.fields === "droppedCoverage" ? 0 : 1;
    } else if (showMoreClick) {
      offset = valueRow.innerTable.data.length + 1;
    } else {
      this.appService.logUserAction(
        {},
        this.ticker,
        "HOME",
        "HIDE_OLD_MODEL",
        "COMPANY_PAGE",
        valueRow.brokerShortName,
        null,
      );
      return;
    }
    const paramsToPass = {
      companyId: this.companyId,
      sourceId: valueRow.sourceId,
      offset: offset,
      brokerShortName: valueRow.brokerShortName,
    };
    const innerTableData = [];
    if (
      offset === 1 &&
      valueRow.fields === "notCurrentModel" &&
      valueRow.subRow
    ) {
      innerTableData.push(valueRow.subRow);
    }

    this.service.getAnalystModelRowData(paramsToPass).subscribe(
      (resp) => {
        resp.data.forEach((valueSubRow) => {
          const subRow = {
            eventDate:
              valueSubRow.event_date !== null &&
              typeof valueSubRow.event_date === "string"
                ? (valueSubRow.event_date as string).replace("Z", "")
                : valueSubRow.event_date,
            dayDiff: valueSubRow.daydiff,
            analystId: valueSubRow.analyst_id,
            analystName: valueSubRow.analyst_name,
            analystEmail: String(valueSubRow.analyst_email).toLowerCase(),
            fileSize: valueSubRow.file_size,
            fileName: valueSubRow.file_name,
            transactionId: valueSubRow.TransactionId,
            modelType: valueSubRow.model_type,
            model_date: valueSubRow.model_date,
            downloadApplicable: valueSubRow.download_applicable,
            documentId: valueSubRow.document_id,
            fileType: valueSubRow.file_type,
            brokerShortName: valueRow.brokerShortName,
            hasDuplicate: valueSubRow.has_duplicate,
            statedperiodtooltip: valueSubRow.statedperiod,
            documentType: valueSubRow.document_type,
            pg: valueRow.pg,
            showViewLink:
              this.userType !== "MODELS_ONLY_INBOX" &&
              valueRow.pg !== "" &&
              valueRow.drop_coverage === 0 &&
              valueRow.is_give_to_get_src === 0 &&
              valueSubRow.coverage_analyst_data === 1,
            duplicateList: [],
            guidance: valueSubRow.guidance ? valueSubRow.guidance : false,
          };
          innerTableData.push(subRow);
        });
        const offset =
          valueRow.innerTable.data.length + innerTableData.length + 1;
        const showMoreCount =
          valueRow.totalModels - offset > 5 ? 5 : valueRow.totalModels - offset;
        valueRow.innerTable = {
          show: true,
          showMoreCount: showMoreCount,
          offset: offset,
          data: [...valueRow.innerTable.data, ...innerTableData],
        };
      },
      (err) => {
        this.errorMsg = err.msg;
        throw err;
      },
    );
    this.appService.logUserAction(
      {},
      this.ticker,
      "HOME",
      showMoreClick ? "SHOW_MORE_MODEL" : "SHOW_OLD_MODEL",
      "COMPANY_PAGE",
      valueRow.brokerShortName,
      null,
    );
  }
  modelDownloadClick(row, brokerShortName) {
    const extraParams = {
      companyId: this.companyId,
      cut: "HOME",
      source: brokerShortName,
      pg: row.pg,
      transactionId: row.transactionId,
    };

    this.appService.excelDownload("model_download", extraParams);
  }

  openFilings(row, isExpandedRow, isInterim) {
    const documentId = isExpandedRow
      ? row.documentId
      : isInterim
        ? row.interimData.document_id
        : row.earningsData.document_id;
    this.documentId = documentId;
    const fileType = isExpandedRow
      ? row.file_type
      : isInterim
        ? row.interimData.file_type
        : row.earningsData.file_type;
    const filingsTitle = "<b>Company Announcements";
    this.filingsHeading = `${filingsTitle} |</b> ${row.statedperiodtooltip}`;
    this.documentType =
      typeof row.documentType === "string"
        ? row.documentType
        : row.documentType.document_type;
    const eventDate = row.eventDate ? row.eventDate : row.subRow.eventDate;
    const dayDiff = row.dayDiff ? row.dayDiff : row.subRow.dayDiff;
    this.datePublish = `${new DatePipe("en-US").transform(
      eventDate,
      "dd-MMM-yy",
    )} (${dayDiff})`;

    this.currentGuidance = 0;
    this.guidanceCount = 0;
    if (fileType !== "xlsx") {
      //open in iframe
      const params = {
        downloadType: "filings",
        documentId: documentId,
        companyId: this.companyId,
        pg: "IS",
        cut: "NMV",
        file_type: fileType,
      };
      this.filingsError = false;

      this.service.getViewModelSrc(params).subscribe((msg) => {
        this.filingFileType = msg["fileType"];
        const param = {
          documentId: documentId,
        };

        if (msg["fileType"] === "htm" || msg["fileType"] === "html") {
          //load modal with src
          this.isViewModalVisible = true;
          const options = {
            responseType: "text" as const,
          };
          this.hasGuidance = msg.guidance;
          this.openFilingDialog();
          if (msg.guidance) {
            this.service.getGuidanceData(param).subscribe(
              (response) => {
                // logic for guidance stuff
                const doc =
                  document.getElementById("filingsFrame")["contentWindow"]
                    .document;
                if (doc && response) {
                  doc.open();
                  doc.write(response);
                  doc.close();
                  setTimeout(() => {
                    this.service
                      .getGuidanceList(param)
                      .subscribe((response) => {
                        this.guidanceList = response["data"].guidances;
                        this.guidanceCount = this.guidanceList.length;
                        if (this.dialogRef?.componentInstance) {
                          this.dialogRef.componentInstance.data = {
                            ...this.dialogRef.componentInstance.data,
                            guidanceCount: this.guidanceCount,
                          };
                        }
                        const filingsDocClass = document
                          .getElementById("filingsFrame")
                          ["contentWindow"].document.getElementsByClassName(
                            "bkmk_filings_span_class",
                          );
                        for (let i = 0; i < filingsDocClass.length; i++) {
                          filingsDocClass[i].style.backgroundColor = "#FFEFCB";
                        }
                      });
                  }, 1000);
                }

                // this.loadGuidance();
              },
              (error) => {
                console.error(error);
              },
            );
          } else {
            this.http.get(msg.url, options).subscribe(
              (htmlData) => {
                const doc =
                  document.getElementById("filingsFrame")["contentWindow"]
                    .document;
                if (doc && htmlData) {
                  doc.open();
                  doc.write(htmlData);
                  doc.close();
                }
              },
              (error) => {
                console.error(error);
              },
            );
          }
          // this.viewModalSrc = this.sanitizer.bypassSecurityTrustResourceUrl(
          //   msg.url,
          // );
        }
        if (msg["fileType"] === "pdf") {
          const options = {
            responseType: "arraybuffer",
          };
          const filingsParams = {
            documentId: documentId,
          };
          this.isViewModalVisible = true;
          this.gettingPDFURL = true;
          this.openFilingDialog();
          this.service.getPDFFilings(filingsParams, options).subscribe(
            (pdfData) => {
              if (pdfData["status"] === "error") {
                console.error(pdfData["message"]);
              } else {
                const file = new Blob([pdfData], { type: "application/pdf" });
                const fileURL = URL.createObjectURL(file);
                this.viewModalSrc =
                  this.sanitizer.bypassSecurityTrustResourceUrl(fileURL);
                this.filingsError = false;
                this.gettingPDFURL = false;
                if (this.dialogRef?.componentInstance) {
                  this.dialogRef.componentInstance.data = {
                    ...this.dialogRef.componentInstance.data,
                    gettingPDFURL: this.gettingPDFURL,
                    filingsError: this.filingsError,
                    viewModalSrc: this.viewModalSrc,
                  };
                }
                // document
                //   .getElementById("AMSFilingsFrame")
                //   .setAttribute("src", fileURL);
              }
            },
            (error) => {
              console.error(error);
            },
          );
        }
        if (msg.status === "error") {
          //show error
          this.filingsError = true;
          this.isViewModalVisible = true;
          this.openFilingDialog();
        }

        if (msg.force_logout) {
          window.location.href = `${this.legacyUrl}/homepage/?force_logout=true`;
        }
        this.appService.logUserAction(
          {},
          this.ticker,
          "",
          this.hasGuidance
            ? "FILINGS_WITH_GUIDANCE"
            : "FILINGS_WITHOUT_GUIDANCE",
          {
            documentId: this.documentId,
          },
          "",
          null,
        );
      });
    } else {
      //call model download
      const extraParams = {
        companyId: this.companyId,
        cut: "HOME",
        source: row.brokerShortName,
        pg: row.pg,
        transactionId: row.transactionId,
        file_type: fileType,
      };

      this.appService.excelDownload("model_download", extraParams);
    }
  }
  handleCancel() {
    this.isViewModalVisible = false;
    this.hasGuidance = false;
  }
  // loadGuidance(){
  //   this.service.getGuidanceData()
  // }
  onNextGuidance() {
    if (this.currentGuidance < this.guidanceCount) {
      this.currentGuidance += 1;
      if (this.dialogRef?.componentInstance) {
        this.dialogRef.componentInstance.data = {
          ...this.dialogRef.componentInstance.data,
          currentGuidance: this.currentGuidance,
        };
      }
      const guidanceId =
        this.guidanceList[this.currentGuidance - 1].start_tag_id;
      const filingsDoc = document
        .getElementById("filingsFrame")
        ["contentWindow"].document.getElementById(guidanceId);
      filingsDoc.scrollIntoView();
      const currFilingsDocClass = document
        .getElementById("filingsFrame")
        ["contentWindow"].document.getElementsByClassName(`bkmk_${guidanceId}`);
      const allfilingsDocClass = document
        .getElementById("filingsFrame")
        ["contentWindow"].document.getElementsByClassName(
          "bkmk_filings_span_class",
        );
      for (let i = 0; i < allfilingsDocClass.length; i++) {
        allfilingsDocClass[i].style.backgroundColor = "#FFEFCB";
      }
      for (let i = 0; i < currFilingsDocClass.length; i++) {
        currFilingsDocClass[i].style.backgroundColor = "#FFC846";
      }
      this.appService.logUserAction(
        {},
        this.ticker,
        "HOME",
        "GUIDANCE_NAVIGATION_CLICK",
        {
          documentId: this.documentId,
        },
        "",
        null,
      );
    }
  }
  onPrevGuidance() {
    if (this.currentGuidance > 1) {
      this.currentGuidance -= 1;
      if (this.dialogRef?.componentInstance) {
        this.dialogRef.componentInstance.data = {
          ...this.dialogRef.componentInstance.data,
          currentGuidance: this.currentGuidance,
        };
      }
      const guidanceId =
        this.guidanceList[this.currentGuidance - 1].start_tag_id;
      const filingsDoc = document
        .getElementById("filingsFrame")
        ["contentWindow"].document.getElementById(guidanceId);
      filingsDoc.scrollIntoView();
      const currFilingsDocClass = document
        .getElementById("filingsFrame")
        ["contentWindow"].document.getElementsByClassName(`bkmk_${guidanceId}`);
      const allfilingsDocClass = document
        .getElementById("filingsFrame")
        ["contentWindow"].document.getElementsByClassName(
          "bkmk_filings_span_class",
        );
      for (let i = 0; i < allfilingsDocClass.length; i++) {
        allfilingsDocClass[i].style.backgroundColor = "#FFEFCB";
      }
      for (let i = 0; i < currFilingsDocClass.length; i++) {
        currFilingsDocClass[i].style.backgroundColor = "#FFC846";
      }

      this.appService.logUserAction(
        {},
        this.ticker,
        "HOME",
        "GUIDANCE_NAVIGATION_CLICK",
        {
          documentId: this.documentId,
        },
        "",
        null,
      );
    }
  }
  bindPrioritize(brokerShortName) {
    window.Usersnap.init({
      button: { isHidden: true },
    });
    window.Usersnap.on("open", (event) => {
      event.api.setValue("custom", {
        email: `##${this.snapEmail}##`,
        username: this.userName,
        ticker: this.ticker,
      });
      event.api.setValue("email", this.snapEmail);
      event.api.setValue("comment", `Add broker model for ${brokerShortName}`);
    });
    setTimeout(function () {
      window.Usersnap.open();
    }, 1000);
  }
  getDuplicateMsg(sourceId, subRow) {
    this.service
      .getDuplicateModelData({
        sourceId: sourceId,
        transactionId: subRow.transactionId,
        modelType: subRow.modelType,
      })
      .subscribe((resp) => {
        subRow.duplicateList = resp.duplicate_records;
      });
  }

  openFilingDialog(): void {
    if (this.dialogRef) {
      this.dialogRef.close();
    }
    this.dialogRef = this.dialog.open(CompanyAnnouncementDialogComponent, {
      width: "800px",
      height: "558px",
      panelClass: "resizable-mat-dialog-panel",
      hasBackdrop: true,
      data: {
        filingsHeading: this.filingsHeading,
        gettingPDFURL: this.gettingPDFURL,
        documentType: this.documentType,
        datePublish: this.datePublish,
        hasGuidance: this.hasGuidance,
        filingFileType: this.filingFileType,
        filingsError: this.filingsError,
        guidanceCount: this.guidanceCount,
        currentGuidance: this.currentGuidance,
        viewModalSrc: this.viewModalSrc,
        cut: "NMV",
        documentId: this.documentId,
        ticker: this.ticker,
      },
    });

    this.dialogRef.componentInstance.closeClicked.subscribe(() => {
      this.closeFilingDialog();
    });

    this.dialogRef.componentInstance.onNextGuidanceClicked.subscribe(() => {
      this.onNextGuidance();
    });

    this.dialogRef.componentInstance.onPrevGuidanceClicked.subscribe(() => {
      this.onPrevGuidance();
    });
  }

  closeFilingDialog() {
    if (this.dialogRef) {
      this.hasGuidance = false;
      this.dialogRef.close();
    }
  }
}
